export default "__VITE_ASSET__CNd9JHQ2__"